import styled from 'styled-components';

export const ViewRequestLink = styled.button`
  background: none;
  border: none;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  font: inherit;

  &:hover {
    opacity: 0.8;
  }
`;
